import { GlSprintf } from '@gitlab/ui';
import { n__ } from '~/locale';
import MrCollapsibleExtension from '../mr_collapsible_extension.vue';
import Deployment from './deployment.vue';
export default {
    name: 'DeploymentList',
    components: {
        Deployment,
        GlSprintf,
        MrCollapsibleExtension
    },
    props: {
        deployments: {
            type: Array,
            required: true
        },
        deploymentClass: {
            type: String,
            required: true
        }
    },
    computed: {
        showCollapsedDeployments () {
            return this.deployments.length > 3;
        },
        multipleDeploymentsTitle () {
            return n__('Deployments|%{deployments} environment impacted.', 'Deployments|%{deployments} environments impacted.', this.deployments.length);
        }
    }
};
